import Service from "../Service";

const resource = "dashboard/";

export default {
    getOrderPurchaseReport(filters) {
        return Service.post(resource + "orderpurchasereport", filters);
    },
    getPipelineStats(filters) {
        return Service.post(resource + "pipelinestats", filters);
    },
    syncDashboardData() {
        return Service.post(resource + "sync");
    },
    getDashboardLastSync() {
        return Service.get(resource + "last-sync");
    }
};
